import full01 from '../../../assets/images/fulls/01.jpg'
import full02 from '../../../assets/images/fulls/02.jpg'
import full03 from '../../../assets/images/fulls/03.jpg'
import full04 from '../../../assets/images/fulls/04.jpg'
import full05 from '../../../assets/images/fulls/05.png'
import full06 from '../../../assets/images/fulls/06.png'
import thumb02 from '../../../assets/images/thumbs/02.jpg'
import thumb01 from '../../../assets/images/thumbs/01.jpg'
import thumb03 from '../../../assets/images/thumbs/03.jpg'
import thumb04 from '../../../assets/images/thumbs/04.jpg'
import thumb05 from '../../../assets/images/thumbs/05.png'
import thumb06 from '../../../assets/images/thumbs/06.png'


export const DEFAULT_IMAGES = [
    {
      id: '1',
      source: full01,
      thumbnail: thumb01,
      caption: 'Ecommerce(Django)',
      description: 'Fully functional eCommerece website with user and guest checkout capabilities.',
      git:'https://github.com/AjayJangid17/Ecommerce_Django',
      site:'https://eccomerce-django.herokuapp.com/'
    },
    {
      id: '2',
      source: full02,
      thumbnail: thumb02,
      caption: 'Covid-19 Tracker(ReactJS)',
      description: 'COVID-19 Tracker/Stats Application Used React with the addition of Charts.js, Material UI, including React Hooks, API data fetching,folder structure.This project is fetching the live data from the API using Async/Await syntax.',
      git:'https://github.com/AjayJangid17/Covid19_ReactJS',
      site:'https://covid-19tracker-app.netlify.app/'
    },
    
    {
      id: '3',
      source: full03,
      thumbnail: thumb03,
      caption: 'BookStore(Django)',
      description: 'Bokkstore with ReadBooks and multiple categories on Individual login option.Django CRUD opration on books.',
      git:'https://github.com/AjayJangid17/Bookstore',
      site:'http://ajayjangid.pythonanywhere.com/'
    },
    {
      id: '4',
      source: full05,
      thumbnail: thumb05,
      caption: 'Team Chat App Build on React',
      description: 'Chat application usign ReactJs,all functionality like who read the message,image support,sound notification and multiple char rooms.Using chartengine.io,  user:test,pass:1234,',
      git:'https://github.com/AjayJangid17/TeamChat-App-ReactJS',
      site:'https://developerstacks-community.netlify.app/'
    },
    {
      id: '5',
      source: full04,
      thumbnail: thumb04,
      caption: 'Weather App(Django)',
      description: 'Simple Weather App to Search with multiple cities to check current weather forcast and also add favourite city in list.',
      git:'#',
    },
    
    // {
    //   id: '6',
    //   source: full06,
    //   thumbnail: thumb06,
    //   caption: 'Python',
    //   description: 'Python code on PyQT5 Calculator,User&OTP Generator etc..!!',
    //   git:'https://github.com/AjayJangid17/Python',
    // }
]